import React, { ReactElement } from 'react';

interface LabelIconProps {
  icon: ReactElement;
  label: string;
  onClick?: () => void;
  className?: string;
  href?: string;
}

const LabelIcon: React.FC<LabelIconProps> = ({ icon, label, onClick, className, href }) => {
  const content = (
    <div onClick={onClick} className={`flex flex-col items-center ml-6 cursor-pointer select-none ${className}`}>
      <div className="text-[24px]">{icon}</div>
      <span className="text-sm">{label}</span>
    </div>
  );

  return href ? (
    <a href={href} className="text-black hover:text-black hover:no-underline focus:text-black focus:no-underline">
      {content}
    </a>
  ) : (
    content
  );
};

export default LabelIcon;
